export const SHLRQualityItems = [
  "S-HLR Barn",
  "S-HLR Vuxen",
  "A-HLR Barn",
  "A-HLR Vuxen"
] as const;

export const SearchSAHLRGroup = {
  name: "S/A HLR",
  items: SHLRQualityItems
};
